<template>
<div class="organization-table-data">
    <el-table v-if="!isPortrait" :data="detailTableData" :height="dataType=='capacityData'?'30vh':145" style="width: 100%;">
        <el-table-column v-for="(item, index) in tableHeader" :key="index" :prop="item.prop" :label="item.label" :min-width="item.width" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row[scope.column.property]}}</template>
        </el-table-column>
    </el-table>
    <el-table v-if="isPortrait" class="portraitTable" :data="getValues" :show-header="false" style="width: 100%;">
        <el-table-column v-for="(item, index) in getHeaders" :key="index" :prop="item" :min-width="item.width" align="center" show-overflow-tooltip></el-table-column>
    </el-table>
</div>
</template>

<script>
export default {
    props: {
        detailTableData: {
            type: Array
        },
        tableHeader: {
            type: Array
        },
        isPortrait: {
            type: Boolean
        },
        dataType: {
            type: String
        }
    },
    data() {
        return {
            tableData: []
        }
    },
    computed: {
        getHeaders() {
            return this.detailTableData.reduce((pre, cur, index) => pre.concat(`value${index}`), ['title'])
        },
        getValues() {
            return this.tableHeader.map(item => {
                return this.detailTableData.reduce((pre, cur, index) => Object.assign(pre, {
                    ['value' + index]: cur[item.prop]
                }), {
                    'title': item.label,
                });
            });
        }
    },
    mounted() {
        // console.log(this.dataType)
    },
    methods: {}
}
</script>

<style lang="scss">
.organization-table-data {
    .el-table th {
        font-size: 12px;
        font-family: PingFang;
        font-weight: 400;
        color: #08265F;
        background: #f3f7ff;
        padding: 0;
    }

    .el-table td {
        font-size: 12px;
        font-family: PingFang;
        font-weight: 500;
        color: #19191A;
        height: 27px;
        background: #E8F0FF;
        border-bottom: 5px solid #f3f7ff;
        padding: 5px 0;
    }

    .el-table--border::after,
    .el-table--group::after,
    .el-table::before,
    .el-table__body-wrapper {
        background-color: #f3f7ff;
    }

    .portraitTable {
        .el-table .cell.el-tooltip {
            width: 100px !important;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/organization-table-data.vue